module.exports = __webpack_public_path__ + "img/nurole-logo.fa9fe34.svg";